module.exports = __webpack_public_path__ + "img/About Icon - white.cc9c037e.svg";